/* src/app/rating/intro/intro.component.scss */
div.full-bg-cover {
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: 1;
  transform: translateX(-50%) translateY(-50%);
  background:
    linear-gradient(
      47deg,
      #1f1f24,
      rgba(0, 0, 0, 0.8) 75%,
      rgba(0, 0, 0, 0)),
    url(/assets/img/interview_question/interview-question-finsihed-bg.jpg) no-repeat;
  background-size: cover;
  transition: 1s opacity;
}
div.text-center {
  text-align: left !important;
  left: 14%;
  z-index: 2;
  position: absolute;
  width: 60%;
  top: 50%;
  transform: translate(0%, -50%);
}
div.text-center p {
  margin: 0 0 24px 0;
  line-height: 1.75;
}
/*# sourceMappingURL=intro.component.css.map */
